import { dataAbstract } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAbstract = /*#__PURE__*/createIcon(dataAbstract)
export default IconAbstract
